<div class="dialog-container">
  <div flex layout-align="space-between center" layout="row">
    @if (isNewItem) {
      <div class="modal-dialog-title" [translate]="'clients.newBlacklist'" flex>
        Add in blacklist
      </div>
    }
    @if (!isNewItem) {
      <div
        class="modal-dialog-title"
        [translate]="'clients.editBlacklist'"
        flex
      >
        Edit in blacklist
      </div>
    }
    <button tabindex="-1" mat-icon-button (click)="onNoClick()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <hr />
  <form
    [itfgPermissions]="'BLACKLIST_WRITE'"
    layout="column"
    novalidate
    [formGroup]="blacklistEditForm"
    (ngSubmit)="onSubmit($event)"
  >
    @if (identityFixed) {
      <div class="identity-row" layout="row" layout-align="start center">
        <mat-form-field flex="50">
          <mat-label>{{ 'clients.chooseType' | translate }}</mat-label>
          <input matInput type="text" readonly value="{{ typeDisplayName }}" />
        </mat-form-field>
        <mat-form-field flex="50">
          <mat-label>{{
            gridSecondColumnTranslations[selectedBlacklistType] | translate
          }}</mat-label>
          <input
            matInput
            type="text"
            readonly
            value="{{ blacklistEditData?.value }}"
          />
        </mat-form-field>
      </div>
    } @else {
      <div flex="100" layout="row" layout-wrap layout-align="start center">
        <mat-form-field flex class="edit-blacklist-aditional-padding">
          <mat-select
            required
            matInput
            formControlName="blacklistType"
            (selectionChange)="selectedValueChanged()"
            placeholder="{{ 'clients.chooseType' | translate }}"
          >
            @for (blacklistType of blacklistTypes; track blacklistType) {
              <mat-option
                [disabled]="['BLACKLIST_WRITE'] | isUnauthorized | async"
                [value]="blacklistType.id"
                >{{ blacklistType.name }}</mat-option
              >
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field flex class="edit-blacklist-aditional-padding">
          <textarea
            matInput
            required
            formControlName="value"
            placeholder="{{
              gridSecondColumnTranslations[selectedBlacklistType] | translate
            }}"
            (paste)="bulkAddPaste($event)"
          >
          </textarea>
          @if (blacklistFormArr.hasError('required')) {
            <mat-error [translate]="'forms.required'">required</mat-error>
          }
          @if (invalidValues && blacklistFormArr.invalid) {
            <mat-hint [ngStyle]="{ color: '#d32f2f' }"
              >{{ 'clients.blacklistImportInvalid' | translate
              }}{{ invalidValues }}</mat-hint
            >
          }
        </mat-form-field>
      </div>
    }

    <mat-checkbox [formControl]="allBrandsControl" class="all-brands-checkbox">
      <span>{{ 'brands.allBrands' | translate }}</span>
    </mat-checkbox>

    <div class="brand-rows">
      @if (allBrandsControl.value) {
        <div
          class="brand-row"
          layout="row"
          layout-align="start center"
          [formGroup]="globalRowForm"
        >
          <img
            class="all-brands-logo"
            src="assets/images/itf.png"
            [matTooltip]="'brands.allBrands' | translate"
            matTooltipPosition="above"
            alt="ITF logo"
          />
          @if (existingGlobalRecord) {
            <mat-icon
              class="existing-record-icon"
              matTooltip="{{ 'clients.blacklistExistingRecord' | translate }}"
              matTooltipPosition="above"
              >task_alt</mat-icon
            >
          }
          <mat-form-field flex class="brand-row-field">
            <mat-label>{{ 'clients.expire' | translate }}</mat-label>
            <input
              matInput
              formControlName="expire"
              [matDatepicker]="globalPicker"
              [min]="currentDate"
            />
            <div matSuffix layout="row" layout-align="center center">
              <itfg-form-control-clear
                [control]="globalRowForm.get('expire')"
              ></itfg-form-control-clear>
              <mat-datepicker-toggle [for]="globalPicker"></mat-datepicker-toggle>
            </div>
            <mat-datepicker [touchUi]="isMobile()" #globalPicker></mat-datepicker>
            <mat-hint>дд/мм/ГГГГ</mat-hint>
          </mat-form-field>
          <mat-form-field flex class="brand-row-field">
            <mat-label>{{ 'clients.notes' | translate }}</mat-label>
            <input matInput type="text" formControlName="notes" />
          </mat-form-field>
        </div>
      } @else {
        @for (brand of brands; track brand.id; let i = $index) {
          <div
            class="brand-row"
            layout="row"
            layout-align="start center"
            [formGroup]="brandRowAt(i)"
          >
            <mat-checkbox formControlName="checked"></mat-checkbox>
            <itfg-brand-logo [brand]="brand" size="24px"></itfg-brand-logo>
            @if (existingByBrandId[brand.id]) {
              <mat-icon
                class="existing-record-icon"
                matTooltip="{{ 'clients.blacklistExistingRecord' | translate }}"
                matTooltipPosition="above"
                >task_alt</mat-icon
              >
            }
            <mat-form-field flex class="brand-row-field">
              <mat-label>{{ 'clients.expire' | translate }}</mat-label>
              <input
                matInput
                formControlName="expire"
                [matDatepicker]="rowPicker"
                [min]="currentDate"
              />
              <div matSuffix layout="row" layout-align="center center">
                <itfg-form-control-clear
                  [control]="brandRowAt(i).get('expire')"
                ></itfg-form-control-clear>
                <mat-datepicker-toggle [for]="rowPicker"></mat-datepicker-toggle>
              </div>
              <mat-datepicker [touchUi]="isMobile()" #rowPicker></mat-datepicker>
              <mat-hint>дд/мм/ГГГГ</mat-hint>
            </mat-form-field>
            <mat-form-field flex class="brand-row-field">
              <mat-label>{{ 'clients.notes' | translate }}</mat-label>
              <input matInput type="text" formControlName="notes" />
            </mat-form-field>
          </div>
        }
      }
    </div>

    <div
      class="dialog-bottom-nav-bar"
      flex="100"
      layout="row"
      layout-align="end center"
    >
      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="isSaving"
      >
        @if (isSaving) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          <span>{{ 'global.save' | translate }}</span>
        }
      </button>
    </div>
  </form>
</div>
